<template>
  <div v-if="!(dataSource.row.length === 0 && dataSource.tile === 0 && dataSource.scroll === 0 && dataSource.scrolltwo === 0)" class="products-part" :style="{order:h5ConfigDetails[0]['modalOrder']['ProductsHomeOrder'][0]}">
    <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['productsHomeImg']['productsHomeBg'][0]}`" alt="">

    <div class="prod-wrapper">
      <div v-for="(prodSubList, key) in dataSource" :key="key">
        <div v-if="prodSubList && prodSubList.length" :class="key">
          <img v-for="(prod, index) in prodSubList" :key="index" class="main-prod" 
            :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['productsHomeImg'][`${isInIos ? 'ios' : 'android'}ProductsImg`][prod.imgIdx]}`" 
              @click="_buy(prod)" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import { global, MAIN_PROD_FLAG, MAIN_PROD_DISPLAY_STYLE_MAP } from '@/config/global'
import { $findProdByFlag } from '@/util/util'
import appBridge from '@/config/appBridge'

export default {
  name: 'ProductsHome',
  props: ['login'],
  data () {
    return {
      baseUrl,
      global,
      dataSource: {
        [MAIN_PROD_FLAG.ROW]: [],
        [MAIN_PROD_FLAG.TILE]: [],
        [MAIN_PROD_FLAG.SCROLL]: [],
        [MAIN_PROD_FLAG.SCROLLTWO]: []
      },
      products: []
    }
  },
  components: {
  },
  computed: {
    ...mapState(['productList', 'h5ConfigDetails', 'h5ConfigImgPath', 'isInIos', 'userInfo', 'isLogin', 'isOutSide'])
  },
  created () {
  },
  mounted () {
    console.log(this.productList)
    this.products = this.productList.filter((product) => {
      return product.productName.includes(`_blind`) || Number(product.appClientParas.isBlindBox) === 1
      // return Number(product.appClientParas.isBlindBox) === 1 华为渠道调用app接口取不到客户端参数
    })
    console.log(this.products)
    let config = this.h5ConfigDetails[0][`${this.isInIos ? 'ios' : 'android'}ProductConfig`]
    config[`${this.isInIos ? 'ios' : 'android'}DisplayStyle`].forEach((ele, idx) => {
      if (!ele) return

      let flag = config[`${this.isInIos ? 'ios' : 'android'}ProductFlag`][idx]
      let prod = $findProdByFlag(this.products, flag)

      // 站外只展示UI
      if (this.isOutSide) {
        prod = {}
      }

      if (!prod) return
      prod.imgIdx = idx
      this.dataSource[MAIN_PROD_DISPLAY_STYLE_MAP[ele]].push(prod)
    })
  },
  methods: {
    _buy (prod) {
      if (!this.isLogin) {
        return this.login()
      }
      appBridge.startPay(prod, this.userInfo)
      window.eventBus.$emit('payInH5', prod, false)
      this.$sensors.track('app_member_click', {button_name: prod.description})
    }
  }
}
</script>

<style scoped lang="less">
  .products-part{
    position: relative;
    font-size: 0;
    .bg{
      width: 100%;
      height: auto;
      display: block;
    }

    .prod-wrapper {
      position: absolute;
      width: 100%;
      // height: 100%;
      top: 5.2rem;
      left: 0;
      overflow-y: scroll;

      .row, .tile{
        // margin-bottom: 1.2rem;
        margin: 0 1.6rem;
      }

      .row img{
        margin-bottom: 1.2rem;
      }

      .row .main-prod {
        width: 100%;
      }

      .tile {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .tile .main-prod {
        width: 15.9rem;
        margin-bottom: 1.2rem;
      }

      .scroll {
        padding-left: 1.6rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        overflow-x: scroll;
      }

      .scroll .main-prod {
        width: 10.3rem;
        margin-right: 1rem;
      }

      .scroll .main-prod:last-child {
        // margin-right: 0;
      }

      .scrolltwo {
        padding-left: 1.6rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        overflow-x: scroll;
      }

      .scrolltwo .main-prod {
        width: 15.5rem;
        margin-right: 1rem;
      }

      .scrolltwo .main-prod:last-child {
        // margin-right: 0;
      }
    }
  }
</style>